import { defineMessages } from 'react-intl';

export const i18n: {
	type: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterTypePlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	type: {
		id: 'quick-find.filters.names.type',
		defaultMessage: 'Type',
		description: 'Label for filtering by type',
	},
	filterTypePlaceholder: {
		id: 'quick-find.filter.type.placeholder',
		defaultMessage: 'Find type',
		description: 'Placeholder for type filter search input',
	},
	filterLabelSelected: {
		id: 'quick-find.filter.type.label.selected',
		defaultMessage: 'Selected',
		description: 'Type filter label selected',
	},
	filterLabelUnselected: {
		id: 'quick-find.filter.type.label.unselected',
		defaultMessage: 'Available',
		description: 'Type filter label unselected',
	},
});
